import Icon from '../components/Icon.vue'

Icon.register({"eye-dropper":{"width":512,"height":512,"paths":[{"d":"M177.4 206.6L39 345A24-24 0 0 1 32 361.9V424L0 480 32 512 88 480H150.1C156.4 480 162.5 477.5 167 473L305.4 334.6 177.4 206.6zM402.9 237.1L419.9 254.1C429.3 263.4 429.3 278.6 419.9 288L378.9 329C369.6 338.3 354.4 338.4 345 329L183 167C173.7 157.7 173.7 142.5 183 133.1L224 92.1C233.3 82.8 248.5 82.7 257.9 92.1L274.9 109.1 357.5 26.5C392.7-8.7 450-9 485.5 26.5 526 74.6 515.2 124.8 485.5 154.5L402.9 237.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/eye-dropper.js
// module id = slV7
// module chunks = 0